import { createContext } from 'react';

export type AppcuesContextType = Record<string, any>;

export const AppcuesContext = createContext<AppcuesContextType>({});
